import React from 'react'

import _ from 'underscore'

import {Button, Modal, ModalHeader, ModalActions} from '../UI/index.js'
import {formSpacing, FormStack, Input, Select} from '../UI/forms/index.js'
import Countries from '../../utils/Countries.js'

class PreferenceModal extends React.Component {
    constructor(props) {
        super(props)
        this.initialState = {
            open: false,
            preference: {name: ''},
            countries: []
        }
        this.state = this.initialState
    }

    open(product, i, preference, countries) {
        this.setState({open: true, product, i, preference, countries})
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeName(event) {
        const {preference} = this.state
        preference.name = event.target.value
        this.setState({preference})
    }

    onChangeCountries(event) {
        const {preference} = this.state
        preference.countries = event.target.values
        this.setState({preference})
    }

    onRemove() {
        const {product, i} = this.state
        const {remove} = this.props
        remove(product, i)
        this.close()
    }

    onSubmit() {
        const {product, i, preference} = this.state
        const {onChange} = this.props
        onChange(product, i, preference)
        this.close()
    }

    render() {
        const {open, preference, countries} = this.state

        return (
            <Modal style={{width: 400}} show={open} onClose={this.close.bind(this)}>
                <ModalHeader title='Wijzig voorkeuren' onClose={this.close.bind(this)} style={{marginBottom: 0}} />

                <FormStack style={{marginBottom: formSpacing.rowGap}}>
                    <Input
                        label='Naam'
                        value={preference.name}
                        onChange={this.onChangeName.bind(this)}
                    />

                    <Select
                        copy
                        label='Landen'
                        options={countries.map((countryCode) => {
                            const country = _.findWhere(Countries, {code2: countryCode}) || {code2: countryCode, name: countryCode}
                            return {value: country.code2, title: country.name}
                        })}
                        values={preference.countries || []}
                        onChange={this.onChangeCountries.bind(this)}
                    />
                </FormStack>

                <br />
                <ModalActions>
                    <Button variant='text' onClick={this.onRemove.bind(this)}>Verwijder</Button>
                    <Button variant='text' onClick={this.onSubmit.bind(this)}>Opslaan</Button>
                </ModalActions>
            </Modal>
        )
    }
}

export default (PreferenceModal)
